import { Footer, GradientBg, Header } from "../components"
import type { NextPage } from "next"

const CompensationDisclosure: NextPage = () => {
  return (
    <>
      <GradientBg />
      <Header />
      <div className="relative mx-auto py-16 lg:py-32 px-4 prose prose-lg prose-a:text-primary hover:prose-a:text-primaryHover">
        <div className="text-center">
          <h1>Coverdash Compensation Disclosure</h1>
        </div>
        <div className="mt-16">
          <p>
            Coverdash takes pride in providing best in class services to our
            clients and believes you should understand how we are paid for these
            services. The use of Coverdash's software is free. However, for
            providing insurance brokerage services, Coverdash is compensated in
            a variety of ways, including commission and contingency fees paid by
            insurers or our third-party payment vendor.
          </p>

          <p>
            Below is a summary of the types of compensation Coverdash may
            receive:
          </p>

          <h5 className="font-bold">Commissions</h5>

          <p>
            A commission or fee is normally paid to us by the insurer our
            third-party payment servicer for the distribution and servicing of
            your insurance policy. The amount is typically calculated as a
            percentage of the premium paid to the insurer for your policy
            although it may vary depending on several factors, including the
            type of insurance product sold and the specific insurer.
          </p>

          <h5 className="font-bold">Contingent Commissions</h5>

          <p>
            We may also receive income through contingent commissions received
            from insurers because we have achieved certain criteria, typically
            measured on an annual basis. The criteria vary, but are usually the
            result of attracting new customers, retaining existing customers,
            achieving certain loss or claim results or assisting the insurer
            with the underwriting process. Because the amount of contingent
            commission earned may vary, there is generally no meaningful method
            to determine the exact impact that any particular insurance policy
            has on contingency arrangements.
          </p>

          <h5 className="font-bold">Technology Access Fee</h5>

          <p>
            In addition to the policy charges, a Technology Access Fee is
            applicable for each policy purchased, facilitating access to our
            advanced technological infrastructure, platform, and user dashboard.
            This fee contributes to the ongoing development and maintenance of
            our technology, ensuring a seamless and efficient user experience.
            At all times, please note that these fees are fully earned and
            nonrefundable.
          </p>

          <h5 className="font-bold">Supplemental Commissions</h5>

          <p>
            Certain insurance companies pay supplemental commissions – fixed
            amounts – that are based on a broker's performance during the prior
            year. These commissions are established annually and are based on
            the historical performance of the broker. The criteria for
            supplemental commissions are similar to those for contingent
            commissions. Unlike contingent commissions, the amount of
            supplemental commission is known at the time of insurance placement.
          </p>

          <h5 className="font-bold">Client Fees</h5>
          <p>
            Coverdash may, on occasion, negotiate a fee for services in lieu of,
            or in addition to, commissions paid by insurance companies. These
            fees may include, but are not limited to, subscribing, policy
            handling and consulting fees.
          </p>

          <h5 className="font-bold">Affinity Partner Revenue</h5>
          <p>
            We may also receive income from certain affinity partners for our
            referral of customers to their platform or service. Depending on the
            arrangement with each of our affinity partners, Coverdash may be
            compensated for each customer that is directed to our affinity
            partners platform. Coverdash may also be compensated contingent upon
            a customer paying for our affinity partner's service.
          </p>

          <h5 className="font-bold">Other Compensation</h5>

          <p>
            From time to time Coverdash may be compensated by insurers for
            providing administrative services to clients on behalf of those
            insurers. Such amounts are typically calculated as a percentage of
            premium or are based on the number of insureds.
          </p>

          <p>
            Should you have any questions regarding our compensation for your
            specific insurance placement or more generally regarding our
            compensation, please feel free to reach out to your Coverdash agent
            for more information.
          </p>

          <h5 className="font-bold">Auto Pay Enrollment Disclaimer</h5>
          <p>
            By completing a digital transaction or purchase through Coverdash,
            you automatically authorize our payment processing partner to
            automatically charge the payment method you have selected for
            recurring billing cycles. This authorization covers all current and
            future charges associated with your purchase, with payments
            processed on or about the same day each billing period. You
            acknowledge that you are responsible for maintaining valid payment
            information and may opt out of Auto Pay at any time by contacting
            Coverdash customer support or our payment processing partner
            directly.
          </p>
          <p>
            You understand and agree that failure to maintain a valid payment
            method or to opt out may result in service interruption, and that
            continued use of services constitutes acceptance of these automatic
            payment terms. Coverdash reserves the right to modify the Auto Pay
            terms at any time, and you remain responsible for all outstanding
            balances. By completing any digital transaction, you confirm that
            you have read, understood, and consent to these terms, granting
            explicit authorization for recurring automatic payments.
          </p>
        </div>
        <p>Coverdash: Business insurance in a Dash</p>
      </div>
      <Footer />
    </>
  )
}

export default CompensationDisclosure
